// jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// AOS (Animate on Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';
import Swiper from 'swiper';
import { Pagination, Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css/bundle';
// Match Height
import 'jquery-match-height/jquery.matchHeight';


// AOS init on window load
window.addEventListener('load', () => {

    // Header scroll effect
    const masthead = document.querySelector('.masthead');
    if (masthead) {
        const toggleScroll = () => {
            masthead.classList.toggle('is-scrolled', window.scrollY > 50);
        };
        toggleScroll(); // check on load
        window.addEventListener('scroll', toggleScroll, { passive: true });

        // Mobile menu toggle
        const burger = masthead.querySelector('.masthead__burger');
        if (burger) {
            burger.addEventListener('click', () => {
                const isOpen = masthead.classList.toggle('is-menu-open');
                burger.setAttribute('aria-expanded', isOpen);
                document.body.style.overflow = isOpen ? 'hidden' : '';
            });
        }

        // Mobile sub-menu chevron toggles
        const chevronSvg = '<svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>';
        const parentItems = masthead.querySelectorAll('.masthead__menu > li.menu-item-has-children');

        parentItems.forEach((item) => {
            const link = item.querySelector(':scope > a');
            const subMenu = item.querySelector(':scope > .sub-menu');
            if (!link || !subMenu) return;

            // Create chevron toggle button
            const toggle = document.createElement('button');
            toggle.className = 'masthead__submenu-toggle';
            toggle.type = 'button';
            toggle.setAttribute('aria-label', 'Toggle submenu');
            toggle.innerHTML = chevronSvg;
            link.after(toggle);

            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const isOpen = toggle.classList.toggle('is-open');
                subMenu.classList.toggle('is-open', isOpen);
            });
        });

        // Mega menu — set masthead height & toggle classes on hover
        const setMastheadHeight = () => {
            masthead.style.setProperty('--masthead-height', masthead.offsetHeight + 'px');
        };
        setMastheadHeight();
        window.addEventListener('resize', setMastheadHeight, { passive: true });

        const menu = masthead.querySelector('.masthead__menu');
        if (menu) {
            const megaItems = menu.querySelectorAll(':scope > li.menu-item-has-children');
            let closeTimer = null;

            megaItems.forEach((item) => {
                item.addEventListener('mouseenter', () => {
                    clearTimeout(closeTimer);
                    // Close any other open mega items
                    megaItems.forEach(other => other.classList.remove('is-mega-open'));
                    item.classList.add('is-mega-open');
                    menu.classList.add('has-mega-open');
                });

                item.addEventListener('mouseleave', () => {
                    closeTimer = setTimeout(() => {
                        item.classList.remove('is-mega-open');
                        // Check if any are still open
                        const anyOpen = menu.querySelector(':scope > li.is-mega-open');
                        if (!anyOpen) menu.classList.remove('has-mega-open');
                    }, 280);
                });
            });
        }
    }

    AOS.init({
        once: true,
        duration: 800,
        offset: 56,
        easing: 'ease-out',
    });

    // Card Slider — Sectors
    document.querySelectorAll('[data-swiper="sectors"]').forEach((el) => {
        new Swiper(el, {
            modules: [Pagination],
            loop: true,
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    centeredSlides: true,
                },
            },
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });

    // Image Slider — marquee
    document.querySelectorAll('[data-swiper="image-slider"]').forEach((el) => {
        const swiper = new Swiper(el, {
            modules: [Autoplay],
            loop: true,
            speed: 6000,
            slidesPerView: 1.2,
            spaceBetween: 20,
            centeredSlides: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            on: {
                init() {
                    this.wrapperEl.style.transitionTimingFunction = 'linear';
                },
                setTransition() {
                    this.wrapperEl.style.transitionTimingFunction = 'linear';
                },
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });
        el.addEventListener('mouseenter', () => swiper.autoplay.stop());
        el.addEventListener('mouseleave', () => swiper.autoplay.start());
    });

    // Card Slider — Custom (marquee)
    document.querySelectorAll('[data-swiper="card-slider-custom"]').forEach((el) => {
        const swiper = new Swiper(el, {
            modules: [Autoplay],
            loop: true,
            speed: 6000,
            slidesPerView: 1.2,
            spaceBetween: 20,
            centeredSlides: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            on: {
                init() {
                    this.wrapperEl.style.transitionTimingFunction = 'linear';
                },
                setTransition() {
                    this.wrapperEl.style.transitionTimingFunction = 'linear';
                },
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 33,
                },
            },
        });
        el.addEventListener('mouseenter', () => swiper.autoplay.stop());
        el.addEventListener('mouseleave', () => swiper.autoplay.start());
    });

    // Testimonial Slider
    document.querySelectorAll('[data-swiper="testimonial-slider"]').forEach((el) => {
        new Swiper(el, {
            modules: [Pagination, Autoplay],
            loop: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            centeredSlides: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: el.querySelector('.testimonial-slider__pagination'),
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 33,
                },
            },
        });
    });

    // Hero Video Playlist — sequential playback + image sync
    document.querySelectorAll('[data-video-playlist]').forEach((container) => {
        const videos = container.querySelectorAll('video');
        const hero = container.closest('.hero');
        const heroImages = hero ? hero.querySelectorAll('.hero__image[data-slide-index]') : [];

        // Force muted programmatically — iOS requires this for autoplay
        videos.forEach((video) => {
            video.muted = true;
            video.setAttribute('muted', '');
            video.playsInline = true;
            video.setAttribute('playsinline', '');
        });

        if (videos.length <= 1) {
            // Single video — just loop it
            if (videos[0]) {
                videos[0].loop = true;
                videos[0].play().catch(() => { });
            }
            return;
        }

        let current = 0;

        // Kick off the first video
        videos[0].play().catch(() => { });

        videos.forEach((video, i) => {
            video.addEventListener('ended', () => {
                video.classList.remove('is-active');
                if (heroImages.length) {
                    heroImages.forEach(img => img.classList.remove('is-active'));
                }

                current = (i + 1) % videos.length;
                const next = videos[current];
                next.currentTime = 0;
                next.classList.add('is-active');
                next.play().catch(() => { });

                // Sync hero image
                const matchingImage = hero?.querySelector(`.hero__image[data-slide-index="${current}"]`);
                if (matchingImage) matchingImage.classList.add('is-active');
            });
        });
    });

    // Accordion toggle
    document.querySelectorAll('.accordion-block__item-header').forEach((btn) => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.accordion-block__item');
            const body = item.querySelector('.accordion-block__item-body');
            const isOpen = item.classList.contains('is-open');

            // Close all siblings
            item.closest('.accordion-block__items').querySelectorAll('.accordion-block__item').forEach((sibling) => {
                sibling.classList.remove('is-open');
                const sibBody = sibling.querySelector('.accordion-block__item-body');
                if (sibBody) sibBody.style.maxHeight = null;
            });

            // Toggle current
            if (!isOpen) {
                item.classList.add('is-open');
                body.style.maxHeight = body.scrollHeight + 'px';
            }
        });
    });

});
